import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=227bb1bf&scoped=true"
import script from "./createProduct.vue?vue&type=script&lang=js"
export * from "./createProduct.vue?vue&type=script&lang=js"
import style0 from "./createProduct.vue?vue&type=style&index=0&id=227bb1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bb1bf",
  null
  
)

export default component.exports